<mat-form-field class="w-100">
  <mat-label>
    {{ label }}
  </mat-label>
  <mat-chip-grid #chipGrid aria-label="{{ label }} selection">
    @for (chip of chips(); track $index) {
      <mat-chip-row (removed)="removeChip(chip)">
        {{ chipDisplay(chip) }}
        <button matChipRemove [attr.aria-label]="'remove ' + chip">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    name="currentChip"
    placeholder="Select {{ label }}..."
    #chipInput
    [(ngModel)]="currentChip"
    [value]="currentChip()"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="chipAuto"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (blur)="onBlur()"
  />
  <mat-autocomplete
    #chipAuto="matAutocomplete"
    (optionSelected)="chipSelected($event)"
  >
    @for (chip of filteredChips(); track chip) {
      <mat-option [value]="chip">
        {{ chip }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (currentChip()) {
    <button
      matSuffix
      matIconButton
      aria-label="Clear"
      color="warn"
      type="button"
      matTooltip="Clear Search"
      (click)="clearChipSearch()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
